import AjaxForm from 'component/AjaxForm'

export default class NewsletterForm extends AjaxForm {

    handleSuccess = () => {
        this.$form.addClass(this.completeClass)

        $.each(this.inputs, (name, field) => field.disable())

        this.$form.elements.submit
            .attr('disabled', 'disabled')

        this.$form.elements.successMessage
            .append(
                $('<h3 />', {
                    'class': 'aside-module__heading',
                    'text': 'WARE Newsletter'
                })
            )
            .append(
                $('<p />', {
                    'class': 'aside-module__description',
                    'text': 'We’ll keep you up-to-date with all things WARE. While you’re here, take a look at our extensive video library.'
                })
            )
            .append(
                $('<a />', {
                    'class': 'aside-module__all',
                    'href': '/helpful-resources?type=videos',
                    'html': 'View all videos <i class="fa fa-angle-double-right" aria-hidden="true"></i>'
                })
            )

        this.$form
            .velocity({
                opacity: .8
            }, {
                duration: 1500,
                easing: 'easeOutCubic'
            })
            .velocity({
                opacity: 1
            }, {
                begin: () => {
                    this.$form.elements.successMessage
                        .velocity('transition.slideUpIn',{ display: 'flex'})
                },
                complete: () => {
                    this.$form.removeAttr('styles')
                },
                duration: 750,
                easing: [1000, 20]
            })
    };
}